import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MenuService } from '@core/layout/services/menu.service';

@Component({
  selector: 'app-logo',
  imports: [NgOptimizedImage, NgClass],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  protected readonly menuService = inject(MenuService);
}
